import React from "react";
import AdminDisabledField from "features/Admin/components/AdminDisabledField";

const AnalyticsForm = ({ values }) => (
	<div>
		<AdminDisabledField title="Analyseur" value={values.analyzer} />
		<AdminDisabledField title="Volume pipetage (en μL)" value={values.pipette_volume} />
		<AdminDisabledField title="Volume mort analyse (en μL)" value={values.dead_space} />
		<div style={{ marginTop: "1em", fontWeight: 600 }}>Jours de traitement</div>
		<AdminDisabledField title="Lundi" value={values.treatment_day_monday} />
		<AdminDisabledField title="Mardi" value={values.treatment_day_tuesday} />
		<AdminDisabledField title="Mercredi" value={values.treatment_day_wednesday} />
		<AdminDisabledField title="Jeudi" value={values.treatment_day_thursday} />
		<AdminDisabledField title="Vendredi" value={values.treatment_day_friday} />
		<AdminDisabledField title="Samedi" value={values.treatment_day_saturday} />
		<AdminDisabledField title="Dimanche" value={values.treatment_day_sunday} />
	</div>
);

export default AnalyticsForm;
